import React from 'react';
import {Table} from 'reactstrap';

const sortTypes = {
	up: {
		class: 'sort-up',
	},
	down: {
		class: 'sort-down',
	},
	default: {
		class: 'sort',
	}
};

class DuplicatesList extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			currentSort: 'default',
			sortField: ''
		}
	}

	onSortChange = (field) => {
		const { currentSort } = this.state;
		let nextSort;

		if (currentSort === 'down') nextSort = 'up';
		else if (currentSort === 'up') nextSort = 'default';
		else if (currentSort === 'default') nextSort = 'down';

		this.setState({
			currentSort: nextSort,
			sortField: field
		});
	};

	processData = () => {
		const {sortField, currentSort} = this.state;

		var ret = [];
		this.props.duplicates.map(p => {
			if (p.EmailMatch && this.props.filter === "email" ||
				  p.PhoneMatch && this.props.filter === "phone" ||
				  p.EmailMatch && p.PhoneMatch && this.props.filter === "both") {
				ret.push(p);
			}
		});
		if (sortField === '') {
			ret.sort((a, b) => {return a.CreatedTime > b.CreatedTime ? 1 : -1});
		} else {
			switch(currentSort) {
				case 'up':
					ret.sort((a, b) => {return a[sortField] > b[sortField] ? -1 : 1});
					break;
				case 'down':
					ret.sort((a, b) => {return a[sortField] > b[sortField] ? 1 : -1});
					break;
				default:
					ret.sort((a, b) => {return a.CreatedTime > b.CreatedTime ? 1 : -1});
			}
		}
		if (ret.length <= 1000) return ret;
		let start = this.props.pager - 1;
		if (ret.length > this.props.pager * 1000) {
			return ret.slice(start * 1000, this.props.pager * 1000);
		}
		return ret.slice(start * 1000);
	}

	render() {
		const { currentSort, sortField } = this.state;
		var data = this.processData();
		return (
			<Table className="tablesorter" responsive>
				<thead className="text-primary">
					<tr>
						<th className={`sortable`}
							onClick={() => this.onSortChange('Phone')}>
							Phone Number &nbsp;
							{
								sortField == 'Phone' &&
									<i className={`fas fa-${sortTypes[currentSort].class}`}/>
							}
							{
								sortField != 'Phone' &&
									<i className={`fas fa-${sortTypes['default'].class}`}/>
							}
						</th>
						<th className={`sortable`}
							onClick={() => this.onSortChange('Email')}>
							Email &nbsp;
							{
								sortField == 'Email' &&
									<i className={`fas fa-${sortTypes[currentSort].class}`}/>
							}
							{
								sortField != 'Email' &&
									<i className={`fas fa-${sortTypes['default'].class}`}/>
							}
						</th>
						<th className={`sortable`}
							onClick={() => this.onSortChange('ID')}>
							Deal ID &nbsp;
							{
								sortField == 'ID' &&
									<i className={`fas fa-${sortTypes[currentSort].class}`}/>
							}
							{
								sortField != 'ID' &&
									<i className={`fas fa-${sortTypes['default'].class}`}/>
							}
						</th>
						<th className={`sortable`}
							onClick={() => this.onSortChange('CreatedTime')}>
							Date Created &nbsp;
							{
								sortField == 'CreatedTime' &&
									<i className={`fas fa-${sortTypes[currentSort].class}`}/>
							}
							{
								sortField != 'CreatedTime' &&
									<i className={`fas fa-${sortTypes['default'].class}`}/>
							}
						</th>
					</tr>
				</thead>
				<tbody>
					{ data.map(d => {
						return (
							<tr key={d.ID}>
								<td>{d.Phone}</td>
								<td>{d.Email}</td>
								<td>{d.ID}</td>
								<td>{d.CreatedTime}</td>
							</tr>
						)
					})}
				</tbody>
			</Table>
		);
	}
}

export default DuplicatesList;
